import script from "./pignooBegin.vue?vue&type=script&setup=true&lang=js"
export * from "./pignooBegin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__